module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")]), _vm._v(" "), _c('span', [_vm._v("Details in below Table are Inactive in Sales/Expense Tables For Calculation")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.particularFilter ||
        _vm.Filter.headFilter ||
        _vm.Filter.isDeletedFilter ||
        _vm.Filter.billingTypeFilter ||
        _vm.Filter.isActiveFilter ||
        _vm.Filter.isExpInvFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.particularFilter ||
    _vm.Filter.headFilter ||
    _vm.Filter.isDeletedFilter ||
    _vm.Filter.billingTypeFilter ||
    _vm.Filter.isActiveFilter ||
    _vm.Filter.isExpInvFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getExpInvHead.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getExpInvHead', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openHeadModal('', 'Add')
      }
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Exp/Inv type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ExpInvTypeList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.isExpInvFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isExpInvFilter", $$v)
      },
      expression: "Filter.isExpInvFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Clear Status"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.isActiveFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isActiveFilter", $$v)
      },
      expression: "Filter.isActiveFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Delete Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.DeleteStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.isDeletedFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isDeletedFilter", $$v)
      },
      expression: "Filter.isDeletedFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Particular Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Particular Filter",
      "id": "particularFilter",
      "name": "particularFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.particularFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "particularFilter", $$v)
      },
      expression: "Filter.particularFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Head Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Head Filter",
      "id": "headFilter",
      "name": "headFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.headFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "headFilter", $$v)
      },
      expression: "Filter.headFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Updated By User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "updatedByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Updated User"
    },
    on: {
      "input": function($event) {
        _vm.getExpInvHeadDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.updatedByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "updatedByFilter", $$v)
      },
      expression: "Filter.updatedByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getExpInvHead,
      "fields": _vm.ExpInvFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "rem_head_is_exp_inv",
      fn: function(row1) {
        return [_vm._v("\n                " + _vm._s(row1.item.rem_head_is_exp_inv == 0 ?
          "None" :
          row1.item.rem_head_is_exp_inv == 1 ?
          "Invoice" :
          row1.item.rem_head_is_exp_inv == 2 ?
          "Expense" :
          "") + "\n              ")]
      }
    }, {
      key: "rem_head_is_active",
      fn: function(row1) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row1.item.rem_head_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row1.item.rem_head_id,
            "name": "approval",
            "value": row1.item.rem_head_is_active == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row1.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.rem_head_is_active == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row1.item.rem_head_is_active == 1 ? "Active" : "In-Active"))])], 1)])], 1)]
      }
    }, {
      key: "rem_head_created_at",
      fn: function(row1) {
        return [_c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.openHeadModal(row1.item, 'Update')
            }
          }
        }, [_vm._v("View")]), _vm._v(" "), _c('strong', [_vm._v("Created By:")]), _vm._v(" "), (row1.item.rem_head_cu_relation) ? _c('span', [_vm._v(_vm._s(row1.item.rem_head_cu_relation.employeeName)), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Created Date:")]), _vm._v(" " + _vm._s(row1.item.rem_head_created_at)), _c('br'), _vm._v(" "), (row1.item.rem_head_uu_relation) ? _c('strong', [_vm._v("Updated By:")]) : _vm._e(), _vm._v(" "), (row1.item.rem_head_uu_relation) ? _c('span', [_vm._v(_vm._s(row1.item.rem_head_uu_relation.employeeName)), _c('br')]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Updated Date:")]), _vm._v(" " + _vm._s(row1.item.rem_head_updated_at)), _c('br')]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Head-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.ModalType + ' Head'
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Exp/Inv type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ExpInvTypeList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.changeType(_vm.headModal)
      }
    },
    model: {
      value: (_vm.headModal.rem_head_is_exp_inv),
      callback: function($$v) {
        _vm.$set(_vm.headModal, "rem_head_is_exp_inv", $$v)
      },
      expression: "headModal.rem_head_is_exp_inv"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Particular ")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": (_vm.headModal.rem_head_is_exp_inv == '0' || _vm.headModal.rem_head_is_exp_inv == ''),
      "list": _vm.headModal.rem_head_is_exp_inv == '1' ?
        _vm.$store.getters['commonDropdownMaster/getAllInvoiceParticularDDList'] :
        _vm.headModal.rem_head_is_exp_inv == '2' ?
        _vm.$store.getters['commonDropdownMaster/getAllExpenseParticularDDList'] :
        [],
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Select Particular"
    },
    on: {
      "input": function($event) {
        _vm.getParticularsName(_vm.headModal)
      }
    },
    model: {
      value: (_vm.headModal.rem_head_particular),
      callback: function($$v) {
        _vm.$set(_vm.headModal, "rem_head_particular", $$v)
      },
      expression: "headModal.rem_head_particular"
    }
  }), _vm._v(" "), (!_vm.headModal.rem_head_particular) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHeadList.rem_head_particular))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Head "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": !_vm.headModal.rem_head_particular,
      "list": _vm.headModal.rem_head_is_exp_inv == '1' ?
        _vm.$store.getters['commonDropdownMaster/getAllInvoiceHeadDDList'] :
        _vm.headModal.rem_head_is_exp_inv == '2' ?
        _vm.$store.getters['commonDropdownMaster/getAllExpenseHeadDDList'] :
        [],
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Select Head"
    },
    on: {
      "input": function($event) {
        _vm.getParticulars(_vm.headModal)
      }
    },
    model: {
      value: (_vm.headModal.rem_head_title),
      callback: function($$v) {
        _vm.$set(_vm.headModal, "rem_head_title", $$v)
      },
      expression: "headModal.rem_head_title"
    }
  }), _vm._v(" "), (!_vm.headModal.rem_head_title) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHeadList.rem_head_title))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [(_vm.headModal.rem_head_id <= 0 || _vm.headModal.rem_head_id == '') ? _c('b-button', {
    attrs: {
      "disabled": !_vm.headModal.rem_head_title || !_vm.headModal.rem_head_particular || !_vm.headModal.rem_head_is_exp_inv,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addHead
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideHeadModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('b-row', [((_vm.headModal.rem_head_is_exp_inv == '1' || _vm.headModal.rem_head_is_exp_inv == '2') && _vm.headModal.rem_head_particular) ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Inv Type")]), _vm._v(" "), _c('th', [_vm._v("Inv No")]), _vm._v(" "), _c('th', [_vm._v("Ledger Group")]), _vm._v(" "), _c('th', [_vm._v("Buyer")]), _vm._v(" "), _c('th', [_vm._v("Seller")])])]), _vm._v(" "), (_vm.headModal.rem_head_is_exp_inv == '1') ? _c('tbody', _vm._l((_vm.$store.getters['commonDropdownMaster/getAllInvoiceHeadDDList']), function(inv_item, inv_index) {
    return _c('tr', {
      key: inv_index
    }, [_c('td', [_vm._v(_vm._s(inv_item.DocDtls_Typ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inv_item.DocDtls_No))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inv_item.ledger_group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inv_item.BuyerDtls_LglNm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(inv_item.SellerDtls_LglNm))])])
  })) : _vm._e(), _vm._v(" "), (_vm.headModal.rem_head_is_exp_inv == '2') ? _c('tbody', _vm._l((_vm.$store.getters['commonDropdownMaster/getAllExpenseHeadDDList']), function(exp_item, exp_index) {
    return _c('tr', {
      key: exp_index
    }, [_c('td', [_vm._v(_vm._s(exp_item.docDtls_Typ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exp_item.docDtls_No))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exp_item.ledger_group))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exp_item.buyerDtls_LglNm))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(exp_item.sellerDtls_LglNm))])])
  })) : _vm._e()])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b0b345a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/invoice/expInvHeads.vue
// module id = 2810
// module chunks = 0